"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapsibleRow = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const StyledTableRow = (0, styled_components_1.default)(core_1.TableRow) `
  transition: background-color 0.25s cubic-bezier(0.075, 0.82, 0.165, 1);
  &.open {
    background-color: #f7f8fc;
  }
  &:not(.open) .MuiTableCell-root {
    border-bottom: unset;
  }
  .actions {
    padding: 2px;
  }
`;
const CollapsibleRow = (props) => {
    const { open = false, disabled = false, hideAction = false, icon, colSpan, children, collapsedContent, rowProps, collapsedRowProps, className: classNameProp, onIconClick } = props;
    const rowClassName = rowProps === null || rowProps === void 0 ? void 0 : rowProps.className;
    const className = (0, react_1.useMemo)(() => {
        const classes = [];
        open && classes.push('open');
        rowClassName && classes.push(rowClassName);
        classNameProp && classes.push(classNameProp);
        return classes.join(' ');
    }, [open, rowClassName, classNameProp]);
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(StyledTableRow, Object.assign({}, rowProps, { className: className }),
            !hideAction && (react_1.default.createElement(core_1.TableCell, { className: 'actions' },
                react_1.default.createElement(core_1.IconButton, { size: 'small', disabled: disabled, onClick: event => {
                        event.stopPropagation();
                        onIconClick === null || onIconClick === void 0 ? void 0 : onIconClick();
                    } }, icon ? icon : open ? react_1.default.createElement(icons_1.ArrowDropDown, null) : react_1.default.createElement(icons_1.ArrowRight, null)))),
            children),
        react_1.default.createElement(core_1.TableRow, Object.assign({}, collapsedRowProps),
            react_1.default.createElement(core_1.TableCell, { padding: 'none', colSpan: colSpan },
                react_1.default.createElement(core_1.Collapse, { in: open }, collapsedContent)))));
};
exports.CollapsibleRow = CollapsibleRow;
exports.default = exports.CollapsibleRow;
//# sourceMappingURL=CollapsibleRow.js.map